import { render } from "./IconGrip.vue?vue&type=template&id=06b937ff"
import script from "./IconGrip.vue?vue&type=script&lang=js"
export * from "./IconGrip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__